import { render } from "./OrderPayoutsList.vue?vue&type=template&id=65172f10"
import script from "./OrderPayoutsList.vue?vue&type=script&lang=js"
export * from "./OrderPayoutsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__